import { Card, CardTitle, CardPanel, Row, Col, Icon } from 'react-materialize';
import { Link } from "react-router-dom";
import reinShow from './../data/img/rein-show.jpg';

const Music = () => {
    return (
        <Row>
            <h1>Music</h1>
            <CardPanel className="black panel">
                <Row>
                    <Col s={12} m={7} l={7}>
                        <h3>
                            I am Rein. I do music.
                        </h3>
                    </Col>
                    <Col s={12} m={5} l={5}>
                        <Card
                            actions={[
                                <Link key="1" to="/music">Music</Link>,
                            ]}
                            closeIcon={<Icon>close</Icon>}
                            header={<CardTitle image={reinShow}></CardTitle>}
                            revealIcon={<Icon>more_vert</Icon>}
                        >
                        </Card>
                    </Col>
                </Row>
            </CardPanel>
        </Row>
    )
};

export default Music;